import { theme } from '@kmns-internal/furikake'
import { ThemeProvider } from '@mui/material/styles'
import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { SnackbarProvider } from 'src/components/snackbar/SnackbarContext'
import 'src/components/swiper/setupSwiper'
import { AntdConfigProvider } from 'src/features/antd/setupAntd'
import { AuthErrorDialog } from 'src/features/auth/error/Dialog'
import 'src/features/firebase/firebase'
import { initializeGtm } from 'src/features/gtm/initializeGtm'
import { NotificationService } from 'src/features/notificationService/NotificationService'
import { initializeSentry } from 'src/features/sentry/initializeSentry'
import { SetupTanStackQuery } from 'src/features/tanStackQuery/SetupTanStackQuery'
import ErrorBoundary from 'src/libraries/ErrorBoundary'
import { history, store } from 'src/state/store'
import Routes from 'src/views/Routes'
import { UAGuard } from './UAGuard'

initializeSentry()
initializeGtm()

const App: React.FC = () => {
  return (
    <UAGuard>
      <ErrorBoundary>
        <DndProvider backend={HTML5Backend}>
          <Provider store={store}>
            <HelmetProvider>
              <Router history={history}>
                <ThemeProvider theme={theme}>
                  <AntdConfigProvider>
                    <SetupTanStackQuery>
                      <SnackbarProvider>
                        <AuthErrorDialog />
                        <NotificationService />
                        <Routes />
                      </SnackbarProvider>
                    </SetupTanStackQuery>
                  </AntdConfigProvider>
                </ThemeProvider>
              </Router>
            </HelmetProvider>
          </Provider>
        </DndProvider>
      </ErrorBoundary>
    </UAGuard>
  )
}

export default App
